/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface StorageControllerDownloadFile$Params {

/**
 * 파일 URL
 */
  url: string;
}

export function storageControllerDownloadFile(http: HttpClient, rootUrl: string, params: StorageControllerDownloadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'url'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, storageControllerDownloadFile.PATH, 'get');
  if (params) {
    rb.path('url', params.url, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'url'?: string;
      }>;
    })
  );
}

storageControllerDownloadFile.PATH = '/api/storage/download/{url}';
